module.exports = __webpack_public_path__ + "static/media/banner-web-npay@3x.5b2fd641.png";